/**
 * Customer API Service
 * Handles all customer-related API calls
 */

import { apiClient } from '../client';
import type { Customer, CustomerCreate, CustomerListResponse, CustomerAnalytics } from '../../types/api';

export const customersApi = {
  /**
   * Get all customers with optional filters
   */
  getAll: async (params?: {
    skip?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Promise<CustomerListResponse> => {
    const response = await apiClient.get<CustomerListResponse>('/customers/', { params });
    return response.data;
  },

  /**
   * Get customer by ID
   */
  getById: async (id: number): Promise<Customer> => {
    const response = await apiClient.get<Customer>(`/customers/${id}`);
    return response.data;
  },

  /**
   * Create new customer
   */
  create: async (data: CustomerCreate): Promise<Customer> => {
    const response = await apiClient.post<Customer>('/customers/', data);
    return response.data;
  },

  /**
   * Update existing customer
   */
  update: async (id: number, data: Partial<CustomerCreate>): Promise<Customer> => {
    const response = await apiClient.put<Customer>(`/customers/${id}`, data);
    return response.data;
  },

  /**
   * Delete customer
   */
  delete: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete(`/customers/${id}`);
    return response.data;
  },

  /**
   * Get customer analytics
   */
  getAnalytics: async (id: number): Promise<CustomerAnalytics> => {
    const response = await apiClient.get<CustomerAnalytics>(`/customers/${id}/analytics`);
    return response.data;
  },
};

export default customersApi;
